/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./twinMap.vue?vue&type=template&id=f81f538a&scoped=true"
import script from "./twinMap.vue?vue&type=script&lang=js"
export * from "./twinMap.vue?vue&type=script&lang=js"
import style0 from "./twinMap.vue?vue&type=style&index=0&id=f81f538a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81f538a",
  null
  
)

export default component.exports